module.exports = __webpack_public_path__ + "static/wx.87b29dfe.png";